var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AIInfoModal',{attrs:{"current-copy":_vm.currentCopy},on:{"secondary":_vm.handleSecondary,"close":_vm.closeGuidanceDetailsInfoModal}})}
var staticRenderFns = []

export { render, staticRenderFns }